import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router";

import { Button, Division, EmptyState, Flex, Icons, Paragraph, Image } from "@ir/ui";
import { useEffect, useState } from "react";
import { assetsImages } from "@/assets";

const AuthError = () => {
  const { search } = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [errorDescription, setErrorDescription] = useState<string | null>(null);

  useEffect(() => {
    const error = new URLSearchParams(search).get("error");
    const errorDescription = new URLSearchParams(search).get("error_description");
    const errorType = error ? error.replaceAll("_", " ").replaceAll(/\b\w/g, char => char.toUpperCase()) : "Unauthorized";

    setError(errorType);
    setErrorDescription(errorDescription);
  }, [search]);

  return (
    <>
      <Helmet>
        <title>{`401 - ${error}`} | DM WebApp</title>
      </Helmet>
      <Flex className="not-found-page" align="center" justifyContent="center">
        <Division className="flex flex-column flex-align-center" style={{ maxWidth: 700 }}>
          <Image src={assetsImages.IRLogoFull} alt="IR Logo" className="mb-5" />
          <EmptyState
            icon={Icons.InfoOctagon}
            title={<Paragraph className="my-3 d-block font-bold heading text-md">{`401 - ${error}`}</Paragraph>}
            description={errorDescription || "Try logging in again from the application and if the problem persists please contact the administrator"}
          >
            <Link to="/">
              <Button color="primary">Go to Home</Button>
            </Link>
          </EmptyState>
        </Division>
      </Flex>
    </>
  );
};

export default AuthError;
